import { ReactElement } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Popover } from '@mui/material'
import { Paper } from '@components'

const popover = css`
  pointer-events: none;
`

const paper = css`
  max-width: 400px;
  padding: 16px;
`

const Content = styled.div`
  width: 200px;
  height: auto;
`

interface Props {
  open: boolean
  anchorEl: Element | null
  handlePopoverClose: () => void
  children: ReactElement
}

export function DisabledPopover({ children, open, anchorEl, handlePopoverClose }: Props) {
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      css={popover}
      disableRestoreFocus
      onClose={handlePopoverClose}
      open={open}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Paper css={paper}>
        <Content>{children}</Content>
      </Paper>
    </Popover>
  )
}
